import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as logout from "../services/logoutAPI";

//* Logout hook
// export const useLogout = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: () => logout.getLogout(),
//     retry: false,
//     onSuccess: () => {
//       // Clear React Query cache
//       queryClient.clear();

//       // Optionally, clear localStorage/sessionStorage if storing auth tokens
//       localStorage.clear();
//       sessionStorage.clear();
//     },
//   });
// };

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => logout.getLogout(),
    retry: false,
    onSuccess: () => {
      queryClient.clear();
      localStorage.clear();
      sessionStorage.clear();
    },
  });
};
